module.exports = __webpack_public_path__ + "static/team-ie-37d960e7d67f9114fa984c58d8d8721e.png";